export default {
  businessProfile: {
    description:
      'Edite o perfil do seu negócio para que os membros conheçam mais sobre ele.',
    tabs: {
      generalInfo: 'Informações gerais',
      operatingHours: 'Horário de funcionamento'
    }
  },
  generalInfo: {
    fields: {
      name: 'Nome do negócio',
      phone: 'Telefone',
      category: 'Categoria do negócio',
      otherCategory: 'Nome da categoria',
      website: 'Site',
      websiteExample: 'Ex.: cafedobairro.com.br',
      instagram: 'Instagram',
      instagramPlaceholder: 'usuario',
      instagramExample: 'Ex.: cafedobairro',
      facebook: 'Facebook',
      facebookPlaceholder: 'nomedapagina',
      facebookExample: 'Ex.: CafeDoBairro'
    },
    successNotification: 'Perfil atualizado com sucesso!'
  },
  hoursOfOperation: {
    show: 'Exibir',
    sync: {
      title: 'Horário sincronizado com o Google',
      description:
        'O horário de funcionamento do seu negócio está sincronizado com os dados do Google. Desative a sincronização para editar manualmente.'
    },
    selectLocation: 'Selecione a unidade',
    sameTimeForAllLocations: 'Mesmo horário para todas as unidades',
    open: 'Aberto',
    closed: 'Fechado',
    to: 'às',
    days: {
      sunday: 'Domingo',
      monday: 'Segunda-feira',
      tuesday: 'Terça-feira',
      wednesday: 'Quarta-feira',
      thursday: 'Quinta-feira',
      friday: 'Sexta-feira',
      saturday: 'Sábado'
    },
    errors: {
      missingTime: 'Horário inválido: preencha o horário de {day}.',
      sameTime:
        'Horário inválido: em {day}, o horário de abertura é igual ao de fechamento.',
      maxPeriods: 'Você atingiu o limite de períodos por dia.'
    },
    successNotification: 'Horário de funcionamento atualizado com sucesso!'
  },
  manageTeam: {
    heading: 'Equipe',
    list: {
      columns: {
        user: 'Usuário',
        status: 'Status',
        role: 'Função'
      }
    },
    status: {
      accepted: 'Aceito',
      pending: 'Pendente'
    },
    roles: {
      owner: 'Gestor',
      member: 'Usuário'
    },
    actions: {
      transfer: 'Transferir gestão',
      remove: 'Remover usuário',
      resend: 'Reenviar convite',
      removeInvite: 'Remover convite'
    },
    addUser: {
      title: 'Adicionar usuário',
      description:
        'Informe o nome e o e-mail da pessoa que você quer adicionar. Vamos enviar um convite para ela entrar na sua equipe.',
      name: 'Nome',
      email: 'E-mail',
      submit: 'Enviar convite'
    },
    transferDialog: {
      title: 'Transferir gestão',
      description:
        'Você está prestes a transferir a gestão para <b>{name}</b>.',
      cancel: 'Cancelar',
      confirm: 'Transferir'
    },
    notifications: {
      invitationSent: 'Convite enviado',
      managementTransferred: 'Gestão transferida',
      userRemoved: 'Usuário removido',
      invitationRemoved: 'Convite removido',
      invitationResent: 'Convite reenviado'
    }
  }
};
